import { defaultTheme } from '@/config/themes/defaultTheme'
import { atomWithStorage } from 'jotai/utils'

export const GlobalThemePersistentStore = atomWithStorage(
  'globalTheme',
  JSON.parse(localStorage.getItem('globalTheme')) ?? JSON.parse(JSON.stringify(defaultTheme)),
)
